<script>
const { VUE_APP_API_HOST } = process.env

export default {
  data() {
    return {
      plans: {
        free: {
          price: {
            currentPrice: { monthly: 0, annualy: 0, biennially: 0 },
            oldPrice: { monthly: 0, annualy: 0, biennially: 0 }
          },
          condition: {
            user: amount => amount <= 1,
            network: amount => amount <= 1,
            sources: amount => amount <= 1,
            maxUser: 1,
            maxNetwork: 1,
            maxSources: 1
          },
          nbrUtilisateur: 1,
          nbrPages: 1
        },

        starter: {
          price: {
            currentPrice: { monthly: 20, annualy: 200, biennially: 360 },
            oldPrice: { monthly: 9.99, annualy: 95.9, biennially: 179.82 },
            price2026: { monthly: 170, annualy: 1700, biennially: 3060 }
          },

          condition: {
            user: amount => amount <= 5,
            network: amount => amount <= 10,
            sources: amount => amount <= 10,
            maxUser: 5,
            maxNetwork: 10,
            maxSources: 10
          },

          nbrUtilisateur: 5,
          nbrPages: 10,

          option: {
            conciergerie: 100,
            reporting: 50
          }
        },

        standard: {
          price: {
            currentPrice: { monthly: 120, annualy: 1200, biennially: 2160 },
            oldPrice: { monthly: 89.99, annualy: 854.4, biennially: 1619.82 },
            price2026: { monthly: 270, annualy: 2700, biennially: 4860 }
          },

          condition: {
            user: amount => amount <= 50,
            network: amount => amount <= 60,
            sources: amount => amount <= 60,
            maxUser: 50,
            maxNetwork: 60,
            maxSources: 60
          },

          nbrUtilisateur: 50,
          nbrPages: 60,

          option: {
            conciergerie: 150,
            reporting: 0
          }
        },

        premium: {
          price: {
            currentPrice: { monthly: 600, annualy: 6000, biennially: 10800 },
            oldPrice: { monthly: 149.99, annualy: 1430.4, biennially: 2699.82 },
            price2026: { monthly: 600, annualy: 6000, biennially: 10800 }
          },

          condition: {
            user: amount => amount <= 200,
            network: amount => amount <= 250,
            sources: amount => amount <= 250,
            maxUser: 200,
            maxNetwork: 250,
            maxSources: 250
          },

          nbrUtilisateur: 200,
          nbrPages: 250,

          option: {
            conciergerie: 0,
            reporting: 0
          }
        }
      }
    }
  },
  methods: {
    subscribePlan(body) {
      return this.$http
        .post(`${VUE_APP_API_HOST}/subscriptions`, body, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`
          }
        })
        .then(
          res => res,
          err => err
        )
    },

    subscribeOption(body) {
      return this.$http
        .post(`${VUE_APP_API_HOST}/subscriptions/option`, body, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`
          }
        })
        .then(
          res => res,
          err => err
        )
    },

    removeOption(body) {
      return this.$http
        .post(`${VUE_APP_API_HOST}/subscriptions/option/remove`, body, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`
          }
        })
        .then(
          res => res,
          err => err
        )
    },

    getPricePlan(user, type = null) {
      let price = 0
      let userPrenium = user._premium

      if (user._premium && userPrenium.plan > 0 && userPrenium.active) {
        let nameCurrentPlan = userPrenium.plan
          ? Object.keys(this.plans)[userPrenium.plan]
          : 'free'
        if (!this.plans[nameCurrentPlan]) return '0.00'

        let is_old_offer = userPrenium.is_old_offer || false
        let is_2026_plan = userPrenium.is_2026_plan || false

        // --- PERIOD LOGIC ---
        let is_2years = userPrenium.is_2years || false
        let is_annual = userPrenium.is_annual || false

        let priceKey = 'monthly'
        let multiplier = 1

        if (is_2years) {
          priceKey = 'biennially'
          multiplier = 18 // 24 months - 6 free
        } else if (is_annual) {
          priceKey = 'annualy'
          multiplier = 10 // 12 months - 2 free
        }

        let discount =
          (type == 'original' ? 0 : userPrenium.discount || 0) / 100 //convert centime to euro

        // --- PRICE SELECTION LOGIC (using 2 flags) ---
        // Priority order:
        // 1. is_2026_plan=true → price2026 (170€, 270€, 600€) - options INCLUDED
        // 2. is_old_offer=true → oldPrice (9.99€, 89.99€, 149.99€) - options ADDED
        // 3. Default → currentPrice (20€, 120€, 600€) - options ADDED

        let priceObj
        let shouldAddOptions = false

        if (is_2026_plan) {
          // New 2026 plans: options included in base price
          priceObj =
            this.plans[nameCurrentPlan].price.price2026 ||
            this.plans[nameCurrentPlan].price.currentPrice
          shouldAddOptions = false
        } else if (is_old_offer) {
          // Very old customers: use oldPrice + add options
          priceObj = this.plans[nameCurrentPlan].price.oldPrice
          shouldAddOptions = true
        } else {
          // Default: current customers (before 2026) use currentPrice + add options
          priceObj = this.plans[nameCurrentPlan].price.currentPrice
          shouldAddOptions = true
        }

        let basePrice = priceObj[priceKey]

        if (basePrice === undefined || basePrice === null) {
          basePrice = priceObj['monthly'] * multiplier
        }

        price = basePrice - discount

        // --- CALCULATION OF OPTIONS ---
        if (
          shouldAddOptions &&
          userPrenium.options_plan &&
          userPrenium.options_plan.length
        ) {
          for (let option of userPrenium.options_plan) {
            // Check that the option exists for this plan before adding
            if (
              this.plans[nameCurrentPlan].option &&
              this.plans[nameCurrentPlan].option[option]
            ) {
              price += this.plans[nameCurrentPlan].option[option] * multiplier
            }
          }
        }
      }
      return Number.isInteger(price) ? price : price.toFixed(2)
    }
  }
}
</script>
